import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CategoriesModel } from 'src/models/categories.model';
import { CompanyTypeModel } from 'src/models/company_type.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyTypService {
  private companyTypesSubject: BehaviorSubject<Array<CompanyTypeModel>>;
  public companyTypes$: Observable<Array<CompanyTypeModel>>;
  private cachedCompanyTypes: CompanyTypeModel[] | null = null;

  constructor(private http: HttpClient) { 
    this.companyTypesSubject = new BehaviorSubject<Array<CompanyTypeModel>>([]);
    this.companyTypes$ = this.companyTypesSubject.asObservable();
  }


  public get value(): Array<CompanyTypeModel> {
    return this.companyTypesSubject.value;
  }

  update(companyTypes: Array<CompanyTypeModel>){
    this.cachedCompanyTypes = companyTypes;
    this.companyTypesSubject.next(companyTypes);
  }

  list(): Observable<Array<CompanyTypeModel>> {
    if (this.cachedCompanyTypes) {
      console.log('Returning cached company types');
      return of(this.cachedCompanyTypes);
    }
    return this.http.get(`${environment.apiUrl}company_type/`).pipe(
      tap((data: Array<CompanyTypeModel>) => {
        // Mise à jour du cache
        this.cachedCompanyTypes = data;
        console.log('Company types data cached');
      }),
      shareReplay(1) // Partage la réponse entre plusieurs subscribers
    ) as Observable<Array<CompanyTypeModel>>;
  }
}
